import useModal from "@/lib/hooks/useModal";
import type { FormattedFilters } from "@/types/filters";

import UI from "./UI";

interface FilterMenuProps {
  filters: FormattedFilters | undefined;
  productCount: number;
  clearFilters: () => void;
}

const FilterMenu = ({
  filters,
  productCount,
  clearFilters,
}: FilterMenuProps) => {
  const modal = useModal("filterMenu");
  const toggleMenu = modal.toggleModal;
  const show = modal.isOpen;
  const close = modal.closeModal;

  return (
    <UI
      filters={filters}
      toggleMenu={toggleMenu}
      show={show}
      productCount={productCount}
      close={close}
      clearFilters={clearFilters}
    />
  );
};

export default FilterMenu;
